import React, { useState, useEffect } from 'react'

import PurchaseCardContractInfo from './PurchaseCardTab/PurchaseCardContractInfo'
import PurchaseCardAnnotation from './PurchaseCardTab/PurchaseCardAnnotation'
import PurchaseCardUserInfo from './PurchaseCardTab/PurchaseCardUserInfo'

import { Structure } from '../../../Org/Structure/types'
import { PerformanceChart } from '../types'

import { Purchase } from '../../types'

type Props = {
    theme: string
    purchase: Purchase
    purchaseGuid: string
    annotationPurchase: string | null
    onAnnotationPurchaseChange: (value: string | null) => void
    structList: Structure[]
    performanceChart: PerformanceChart | null
    // contractSum: number
    isUserRoleName: string
    onSupervisorChange: (
        guid: string,
        f_name: string,
        l_name: string,
        p_name: string
    ) => void
}

const PurchaseCardTab: React.FC<Props> = (props) => {
    return (
        <div className="flex flex-col w-full gap-5">
            {/* <div className="flex flex-row w-full gap-5">
                <div className="flex flex-col w-full h-60 bg-[#FFFFFF] dark:bg-[#262427] rounded-lg p-3 shadow-lg shadow-[#18181825]">
                    {props.performanceChart ? (
                        <PieChartPerformanceDate
                            contractRegNumber={
                                props.purchase.contract_reg_number
                            }
                            contractStartDate={
                                props.contract.start_execution_date ||
                                'Нет данных'
                            }
                            contractEndDate={
                                props.contract.end_execution_date ||
                                'Нет данных'
                            }
                            initialIndex={1}
                            totalIndex={0}
                            theme={props.theme}
                        />
                    ) : (
                        <div className="flex flex-row text-[#181818] dark:text-[#FFFFFF] text-[16px] w-full h-full items-center justify-center gap-2">
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                            <span>Загрузка</span>
                        </div>
                    )}
                </div>
                <div className="flex flex-col w-full h-60 bg-[#FFFFFF] dark:bg-[#262427] rounded-lg p-3 shadow-lg shadow-[#18181825]">
                    {props.performanceChart ? (
                        <PieChartPerformanceDoc
                            contractSum={props.contractSum}
                            performanceChart={
                                props.performanceChart || 'Нет данных'
                            }
                            initialIndex={1}
                            totalIndex={0}
                            theme={props.theme}
                        />
                    ) : (
                        <div className="flex flex-row text-[#181818] dark:text-[#FFFFFF] text-[16px] w-full h-full items-center justify-center gap-2">
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                            <span>Загрузка</span>
                        </div>
                    )}
                </div>
                <div className="flex flex-col w-full h-60 bg-[#FFFFFF] dark:bg-[#262427] rounded-lg p-3 shadow-lg shadow-[#18181825]">
                    {props.performanceChart ? (
                        <PieChartPerformancePayment
                            contractSum={props.contractSum}
                            performanceChart={
                                props.performanceChart || 'Нет данных'
                            }
                            initialIndex={1}
                            totalIndex={0}
                            theme={props.theme}
                        />
                    ) : (
                        <div className="flex flex-row text-[#181818] dark:text-[#FFFFFF] text-[16px] w-full h-full items-center justify-center gap-2">
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                            <span>Загрузка</span>
                        </div>
                    )}
                </div>
            </div> */}
            <div className="flex flex-row w-full gap-5">
                <div className="flex flex-col w-full gap-5">
                    <PurchaseCardContractInfo
                        theme={props.theme}
                        purchase={props.purchase}
                        purchaseGuid={props.purchaseGuid}
                        structList={props.structList}
                    />
                </div>
                <div className="flex flex-col w-full gap-5">
                    <PurchaseCardUserInfo
                        theme={props.theme}
                        purchase={props.purchase}
                        purchaseGuid={props.purchaseGuid}
                        structList={props.structList}
                        isUserRoleName={props.isUserRoleName}
                        onSupervisorChange={props.onSupervisorChange}
                    />
                    <PurchaseCardAnnotation
                        theme={props.theme}
                        purchaseGuid={props.purchaseGuid}
                        annotationPurchase={props.annotationPurchase}
                        onAnnotationPurchaseChange={
                            props.onAnnotationPurchaseChange
                        }
                    />
                </div>
            </div>
        </div>
    )
}

export default PurchaseCardTab
